import { atomWithReset } from "jotai/utils";

const serviceRequestShowModalOnBackButtonInitialValues = {
  action: null,
  actionBack: null,
  visible: false,
};

export interface ServiceRequestShowModalOnBackButtonStoreInterface {
  visible: boolean;
  action: null | (() => void);
  actionBack: null | (() => void);
}

export const ServiceRequestShowModalOnBackButton = atomWithReset<ServiceRequestShowModalOnBackButtonStoreInterface>(
  serviceRequestShowModalOnBackButtonInitialValues
);
